import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { pageTabHeaderTypographyProps } from "@/App/Layouts/PageBody/PageTabHeader";
import { ViewVariant } from "@/common/ts/layout";
import { ContractDto } from "@/core/api/generated/v1";

import CustomerView from "../../../Customer/View/CustomerView";

interface Props {
  contract: ContractDto;
}

export default function CustomerTabContent({ contract }: Props) {
  return (
    <PageTabContent>
      <CustomerView
        customerId={contract.customer?.id}
        customer={undefined}
        displayProps={{
          breadcrumbs: false,
          header: false,
          actions: true,
          viewVariant: ViewVariant.Tab,
        }}
        headerProps={{
          withLink: true,
          typographyProps: pageTabHeaderTypographyProps.title,
        }}
        onDelete={null}
      />
    </PageTabContent>
  );
}
